import { computed } from 'vue';

export interface Props {
  randomMaxWidthPercent?: number; // random width사용시 width의 최대 퍼센트 값 (100% = 100)
  randomMinWidthPercent?: number; // random width사용시 width의 최소 퍼센트 값 (0% = 0)
  height?: string; // default: 1em, element 높이에 맞출시 100%나 원하는 px값 입력
  width?: string; // default: null, element 길이 맞출시 100%나 원하는 px값 입력
}

export const setup = (props: Props) => {
  const { randomMaxWidthPercent = 0, randomMinWidthPercent = 0, width } = props;
  const boxWidth = computed<string>(
    () =>
      width ||
      `${Math.floor(
        Math.random() * (randomMaxWidthPercent - randomMinWidthPercent) + randomMinWidthPercent,
      )}%`,
  );
  return { boxWidth };
};
